import dados from "./bibliotecas.json" with { type: "json" };

export const { bibliotecas } = dados;
